import React, { createContext, useContext, useEffect, useState } from 'react';

// Utils
import { useAuth } from '@/hooks/useAuth';
import { getBridgeConfigurations } from '@/resources/wallet-service.resource';
import { ethers } from 'ethers';
import { useWeb3 } from './Web3Provider';

const BridgeContext = createContext({});

export const useBridge = () => useContext(BridgeContext);

const initProviders = {
  ethProvider: null,
  l2Provider: null,
};
export function BridgeProvider({ children }) {
  const { fetcher } = useAuth();
  const { provider } = useWeb3();

  const [bridgeData, setBridgeData] = useState(null);
  const [error, setError] = useState(null);
  const [bridgeProviders, setBridgeProviders] = useState(initProviders);

  useEffect(() => {
    async function fetchBridgeDetails() {
      try {
        const data = await fetcher(getBridgeConfigurations());
        setBridgeData(data);
        createProviders();
      } catch (err) {
        setError(err);
      }
    }

    fetchBridgeDetails();
  }, [provider]);

  function createProviders() {
    try {
      const l2Provider = new ethers.providers.JsonRpcProvider(
        bridgeData[1]?.destinationAsset?.blockchainConfiguration?.rpcUrl,
        {
          name: bridgeData[1]?.destinationAsset?.blockchainConfiguration?.name,
          chainId: bridgeData[1]?.destinationAsset?.blockchainConfiguration?.chainId,
        }
      );

      const ethProvider = provider;
      setBridgeProviders({
        ethProvider,
        l2Provider,
      });
    } catch (err) {
      console.error('Unable to create providers', err);
    }
  }

  useEffect(() => {
    if (bridgeData?.length) {
      createProviders();
    }
  }, [bridgeData?.length]);

  return (
    <BridgeContext.Provider value={{ bridgeData, error, bridgeProviders }}>
      {children}
    </BridgeContext.Provider>
  );
}
